import * as React from 'react';
import { ArticleHeading3, Image } from '@cian/ui-kit';
import * as styles from './PikPlusCard.css';

interface IPikPlusCardProps {
  label: string;
  imageUrl: string;
  finishInfo: string;
  price: string;
  subwayInfo?: React.ReactElement | null;
  url: string;
}

export function PikPlusCard(props: IPikPlusCardProps) {
  const { imageUrl, label, finishInfo, price, subwayInfo, url } = props;

  return (
    <a href={url} className={styles['card']} target="_blank" rel="noopener noreferrer" data-testid="pik_plus_card">
      <Image
        alt="image"
        borderRadius="4px"
        display="inline-block"
        height={320}
        objectFit="cover"
        preloader
        src={imageUrl}
        theme="dark"
        width={406}
      />
      <div className={styles['content']}>
        <div className={styles['wrapper']}>
          <div className={styles['label']}>{label}</div>
          <div className={styles['price']}>
            <ArticleHeading3 color="white_100">{price}</ArticleHeading3>
          </div>
          <div className={styles['footer']}>
            <div className={styles['finish-info']}>{finishInfo}</div>
            {subwayInfo && <div className={styles['subway']}>{subwayInfo}</div>}
          </div>
        </div>
      </div>
    </a>
  );
}
